import React from 'react'
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {defaultStaticRanges, createStaticRanges} from 'react-date-range/dist/defaultRanges'
import moment from 'moment'
import {getDateRange, setDateRange} from '../../storage'
import {
  addDays,
 endOfDay,
 startOfDay,
 startOfMonth,
 startOfYear,
 endOfYear,
 endOfMonth,
 addMonths,
 startOfWeek,
 endOfWeek,
 isSameDay,
 differenceInCalendarDays,
  getMonth, getQuarter, getYear, setYear, setMonth
} from 'date-fns';

const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
};

let customStaticRanges = createStaticRanges([
  {
label: 'Today',
range: () => ({
  startDate: defineds.startOfToday,
  endDate: defineds.endOfToday,
}),
},
{
label: 'Yesterday',
range: () => ({
  startDate: defineds.startOfYesterday,
  endDate: defineds.endOfYesterday,
}),
},

{
label: 'This Week',
range: () => ({
  startDate: defineds.startOfWeek,
  endDate: defineds.endOfWeek,
}),
},
{
label: 'Last Week',
range: () => ({
  startDate: defineds.startOfLastWeek,
  endDate: defineds.endOfLastWeek,
}),
},
{
label: 'This Month',
range: () => ({
  startDate: defineds.startOfMonth,
  endDate: defineds.endOfMonth,
}),
},
{
label: 'Last Month',
range: () => ({
  startDate: defineds.startOfLastMonth,
  endDate: defineds.endOfLastMonth,
}),
},
{
  label: 'This Year',
  range : ()=> ({
    startDate: startOfYear(new Date()),
    endDate: endOfYear(new Date()),
  })
},

  {
    label: 'This Fin Year',
    range: ()=>({
        startDate: beginDate ,
        endDate: endDate,
    })
  },
  {
    label: 'Last Fin Year',
    range: ()=>({
        startDate: lastFinBeginDate ,
        endDate: lastFinEndDate,
    })
  }
])
let currentQuarter = getQuarter(new Date())
let currentYear = getYear(new Date())
let endyear, beginyear


if(currentQuarter === 1) {
  // Fin year for jan, feb and march
  beginyear = currentYear - 1
  endyear = currentYear
}
else {
  beginyear = currentYear
  endyear = currentYear + 1
}

let beginDate = startOfMonth(new Date(beginyear, 3))
let endDate = endOfMonth(new Date(endyear, 2))

let lastFinBeginDate = startOfMonth(new Date(beginyear-1, 3))
let lastFinEndDate = endOfMonth(new Date(endyear-1, 2))

export class DRN extends React.Component {


  constructor(props) {
    super(props);
    this.onDateRangeChange = this.onDateRangeChange.bind(this)
    this.toggleDate = this.toggleDate.bind(this)
    this.applyDateRange = this.applyDateRange.bind(this)
    this.dateDisplayFormat = this.dateDisplayFormat.bind(this)
    let dateRange = getDateRange()
    this.state = {
      showDateSelection: false,
      dateRange : dateRange,
      displayDateRange: this.dateDisplayFormat(dateRange),
      customStaticRanges: customStaticRanges
    };
  }


  dateDisplayFormat(dateRange) {
    let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
    let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
    let start_date =  moment(startdate).format('D MMM YYYY')
    let end_date = moment(enddate).format('D MMM YYYY')
    return <small>{start_date+" - "+end_date}</small>
  }

  onDateRangeChange(dateRange) {
    this.setState({dateRange: dateRange.selection})
  }
  applyDateRange() {
    this.props.applyDateRange(this.state.dateRange)
    this.setState({displayDateRange: this.dateDisplayFormat(this.state.dateRange)})
    this.toggleDate()
    setDateRange(this.state.dateRange)
  }

  toggleDate() {
    this.setState({showDateSelection: !this.state.showDateSelection})
  }
  render() {
    let dateRangePicker
    if(this.state.showDateSelection) {
      dateRangePicker =  <div style={{right:15,border:'1px solid #ddd', position:'absolute', backgroundColor:'#fff', zIndex:3}}>
        <DateRangePicker

              editableDateInputs
              showDateDisplay
              ranges={[this.state.dateRange]}
              inputRanges = {[]}
              dateDisplayFormat="dd/MM/yyyy"
              staticRanges = {this.state.customStaticRanges}

              onChange={this.onDateRangeChange}
            />
          <div className="text-right">
          <ul className="list-inline">
          <li><button className="btn btn-sm btn-primary" onClick={this.applyDateRange}>Apply</button></li>
          <li><button className="btn btn-sm btn-default" onClick={this.toggleDate}>Cancel</button></li>
          </ul>
          </div>
      </div>
    }

      return <div>
        <div className="form-control" onClick={this.toggleDate}>{this.state.displayDateRange}</div>
      {dateRangePicker}
    </div>
  }
}


export default class DR extends React.Component {


  constructor(props) {
    super(props);
    this.onDateRangeChange = this.onDateRangeChange.bind(this)
    this.toggleDate = this.toggleDate.bind(this)
    this.applyDateRange = this.applyDateRange.bind(this)
    this.dateDisplayFormat = this.dateDisplayFormat.bind(this)
    let dateRange = typeof sessionStorage.dateRange !== "undefined" ? JSON.parse(sessionStorage.dateRange): this.props.dateRange;
    this.state = {
      showDateSelection: false,
      dateRange : dateRange,
      displayDateRange: this.dateDisplayFormat(dateRange),
    };
  }


  dateDisplayFormat(dateRange) {
    let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
    let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
    let start_date = startdate.getDate()+" "+ moment(startdate).format('MMM')+" "+startdate.getFullYear()
    let end_date = enddate.getDate()+" "+ moment(enddate).format('MMM')+" "+enddate.getFullYear()
    return start_date+" - "+end_date
  }

  onDateRangeChange(dateRange) {
    this.setState({dateRange: dateRange.selection})
  }
  applyDateRange() {
    this.props.applyDateRange(this.state.dateRange)
    this.setState({displayDateRange: this.dateDisplayFormat(this.state.dateRange)})
    this.toggleDate()
    sessionStorage.dateRange = JSON.stringify(this.state.dateRange)
  }

  toggleDate() {
    this.setState({showDateSelection: !this.state.showDateSelection})
  }
  render() {
    let dateRangePicker
    if(this.state.showDateSelection) {
      dateRangePicker =  <div style={{right:15,border:'1px solid #ddd', position:'absolute', backgroundColor:'#fff', zIndex:3}}><DateRangePicker
              ranges={[this.state.dateRange]}
              inputRanges = {[]}
              moveRangeOnFirstSelection = {true}
              onChange={this.onDateRangeChange}
            />
          <div className="text-right">
          <ul className="list-inline">
          <li><button className="btn btn-sm btn-primary" onClick={this.applyDateRange}>Apply</button></li>
          <li><button className="btn btn-sm btn-default" onClick={this.toggleDate}>Cancel</button></li>
          </ul>
          </div>
      </div>
    }

      return <div>
        <div className="form-control" onClick={this.toggleDate}>{this.state.displayDateRange}</div>
      {dateRangePicker}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/daterange.js